import services from 'services'

export default {
  get(uuid, context) {
    if (context && context === 'sequenced-interview') {
      return services.fetch(`/v1/sequenced-interview/candidate/${uuid}`)
    }
    return services.fetch(`/v1/candidate/${uuid}`)
  },

  getEmbeddedCandidate(query) {
    if (query && query.email && query.atsCandidateId) {
      const encodedEmail = encodeURIComponent(query.email)
      const encodedAtsCandidateId = encodeURIComponent(query.atsCandidateId)
      return services.fetch(
        `/v1/candidate/embedded?email=${encodedEmail}&atsCandidateId=${encodedAtsCandidateId}&opening=${query.opening}`
      )
    }
    return services.fetch(`/v1/candidate/embedded`)
  },

  update(candidate, isEmbedded = false) {
    return services.fetch(
      `/v1/candidate/${candidate.uuid}?isEmbedded=${isEmbedded}`,
      {
        method: 'PATCH',
        body: candidate,
      },
    )
  },

  putVideoResponse(uuid, videoResponse) {
    return services.fetch(
      `/v1/candidate/${uuid}/response`,
      {
        method: 'PUT',
        body: videoResponse,
      },
    )
  },

  putMobileVideoResponse(uuid, videoResponse) {
    return services.fetch(
      `/v1/candidate/${uuid}/mobile-response`,
      {
        method: 'PUT',
        body: videoResponse,
      },
    )
  },

  deleteVideoResponse(uuid, videoResponse) {
    return services.fetch(
      `/v1/candidate/${uuid}/response`,
      {
        method: 'DELETE',
        body: videoResponse,
      },
    )
  },

  postAttachment(uuid, attachment) {
    return services.fetch(
      `/v1/candidate/${uuid}/attachments`,
      {
        method: 'POST',
        body: attachment,
      },
    )
  },

  deleteAttachment(uuid, attachment) {
    return services.fetch(
      `/v1/candidate/${uuid}/attachments`,
      {
        method: 'DELETE',
        body: attachment,
      },
    )
  },

  continueLater(uuid) {
    return services.fetch(`/v1/candidate/${uuid}/continue-later`, {
      method: 'POST',
    })
  },

  withdraw(uuid) {
    return services.fetch(`/v1/candidate/${uuid}/withdraw`, {
      method: 'POST',
    })
  },

  reopenInterview(uuid) {
    return services.fetch(`/v1/candidate/${uuid}/reopen`, {
      method: 'POST',
    })
  },

  fetchOpentokSessionData(uuid) {
    return services.fetch(`/v1/candidate/${uuid}/opentokSession`)
  },
}
